/**
 * 官方视频：按 profile 分发（各 profile 独立域名与密钥）
 */
import { submitVolcSeedanceTask, pollVolcSeedanceTask } from './volc-seedance-1.5-pro'
import { submitDashScopeWan22Task, pollDashScopeWan22Task } from './dashscope-wan-2-2'
import { submitDashScopeWan25Task, pollDashScopeWan25Task } from './dashscope-wan-2-5'
import { submitDashScopeWan26Task, pollDashScopeWan26Task } from './dashscope-wan-2-6'
import { submitDashScopeWan22AnimateTask, pollDashScopeWan22AnimateTask } from './dashscope-wan-2-2-animate'
import { submitKlingV25Task, pollKlingV25Task } from './volc-kling-v2-5'
import { submitKlingV26Task, pollKlingV26Task } from './volc-kling-v2-6'
import { submitKlingV3Task, pollKlingV3Task } from './volc-kling-v3'
import { submitMiniMaxHailuo23Task, pollMiniMaxHailuo23Task } from './minimaxi-hailuo-2-3'
import { submitVolcRunwayGen45Task, pollVolcRunwayGen45Task } from './volc-runway-gen-4-5'
import { submitVolcSora2Task, pollVolcSora2Task } from './volc-sora-2'
import { submitGoogleVeo3Task, pollGoogleVeo3Task } from './google-veo-3'
import { submitGoogleVeo31Task, pollGoogleVeo31Task } from './google-veo-3-1'

export function submitOfficialVideo(profileId, params) {
  if (profileId === 'volc-seedance') {
    return submitVolcSeedanceTask(params)
  }
  if (profileId === 'kling-v2-5') {
    return submitKlingV25Task(params)
  }
  if (profileId === 'kling-v2-6') {
    return submitKlingV26Task(params)
  }
  if (profileId === 'kling-v3') {
    return submitKlingV3Task(params)
  }
  if (profileId === 'dashscope-wan-2-2') {
    return submitDashScopeWan22Task(params)
  }
  if (profileId === 'dashscope-wan-2-5') {
    return submitDashScopeWan25Task(params)
  }
  if (profileId === 'dashscope-wan-2-6') {
    return submitDashScopeWan26Task(params)
  }
  if (profileId === 'dashscope-wan-2-2-animate') {
    return submitDashScopeWan22AnimateTask(params)
  }
  if (profileId === 'minimaxi-hailuo-2-3') {
    return submitMiniMaxHailuo23Task(params)
  }
  if (profileId === 'volc-runway-gen-4-5') {
    return submitVolcRunwayGen45Task(params)
  }
  if (profileId === 'volc-sora-2') {
    return submitVolcSora2Task(params)
  }
  if (profileId === 'google-veo-3') {
    return submitGoogleVeo3Task(params)
  }
  if (profileId === 'google-veo-3-1') {
    return submitGoogleVeo31Task(params)
  }
  return Promise.reject(new Error('Unknown official video profile: ' + profileId))
}

export function pollOfficialVideo(profileId, taskId, callback, interval, options) {
  if (profileId === 'volc-seedance') {
    return pollVolcSeedanceTask(taskId, callback, interval)
  }
  if (profileId === 'kling-v2-5') {
    return pollKlingV25Task(taskId, callback, interval, options)
  }
  if (profileId === 'kling-v2-6') {
    return pollKlingV26Task(taskId, callback, interval, options)
  }
  if (profileId === 'kling-v3') {
    return pollKlingV3Task(taskId, callback, interval, options)
  }
  if (profileId === 'dashscope-wan-2-2') {
    return pollDashScopeWan22Task(taskId, callback, interval)
  }
  if (profileId === 'dashscope-wan-2-5') {
    return pollDashScopeWan25Task(taskId, callback, interval)
  }
  if (profileId === 'dashscope-wan-2-6') {
    return pollDashScopeWan26Task(taskId, callback, interval)
  }
  if (profileId === 'dashscope-wan-2-2-animate') {
    return pollDashScopeWan22AnimateTask(taskId, callback, interval)
  }
  if (profileId === 'minimaxi-hailuo-2-3') {
    return pollMiniMaxHailuo23Task(taskId, callback, interval)
  }
  if (profileId === 'volc-runway-gen-4-5') {
    return pollVolcRunwayGen45Task(taskId, callback, interval)
  }
  if (profileId === 'volc-sora-2') {
    return pollVolcSora2Task(taskId, callback, interval)
  }
  if (profileId === 'google-veo-3') {
    return pollGoogleVeo3Task(taskId, callback, interval)
  }
  if (profileId === 'google-veo-3-1') {
    return pollGoogleVeo31Task(taskId, callback, interval)
  }
  throw new Error('Unknown official video profile: ' + profileId)
}
